import { Box, Paper, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ButtonWrapper } from '../../../../../shared/components/formUtilities/useButton';
import { buildLocalizeRoute } from '../../../../../helpers/languageHelper';
import { AppRoutes } from '../../../../../constants/appRoutes';
import visaLogo from '../../../../../assets/images/Visa_Inc._logo.png';
import mastercardLogo from '../../../../../assets/images/Mastercard-logo.png';
import madaLogo from '../../../../../assets/images/mada.png';


export const TransferMethodSelection = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();

	// MADA must be first (first from left to right on English pages)
	// According to MADA branding guidelines
	const paymentLogos = [
		{ src: madaLogo, alt: 'mada' },  // MADA first, lowercase as per guidelines
		{ src: visaLogo, alt: 'Visa' },
		{ src: mastercardLogo, alt: 'MasterCard' },
	];

	const handleDebitCardContinue = () => {
		// Navigate to payment checkout screen
		navigate(
			buildLocalizeRoute(
				`${AppRoutes.Investor}/${AppRoutes.ITransfer}/${AppRoutes.IPayment}/${AppRoutes.IPaymentCheckout}`
			)
		);
	};

	const handleBankTransferViewDetails = () => {
		// Navigate to deposit page
		navigate(
			buildLocalizeRoute(
				`${AppRoutes.Investor}/${AppRoutes.ITransfer}/${AppRoutes.IDeposit}`
			)
		);
	};

	return (
		<Box className="flex flex-col">
			<Box className="grid md:grid-cols-2 grid-cols-1 gap-6 mt-4">
				{/* Debit Card Option */}
				<Paper
					elevation={2}
					className="!p-6 !rounded-lg !bg-white flex flex-col justify-between"
					style={{ minHeight: '300px' }}
				>
					<Box className="flex flex-col">
						<Typography
							variant="h5"
							className="!font-bold !text-gray-800 !mb-4"
						>
							{t('debitCard')}
						</Typography>
						<Box className="flex flex-row gap-3 mt-7 items-center justify-center">
							{paymentLogos.map((logo, index) => {
								// MADA requires minimum 60px height and 1:3 ratio (width = 3x height)
								const isMada = logo.alt === 'mada';
								const logoHeight = '60px'; // MADA minimum requirement
								const logoWidth = isMada ? '180px' : '120px'; // MADA: 3x height, others: proportional
								
								return (
									<Box
										key={index}
										style={{
											height: logoHeight,
											width: logoWidth,
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'center',
										}}
									>
										<img
											src={logo.src}
											alt={logo.alt}
											style={{
												maxHeight: logoHeight,
												maxWidth: logoWidth,
												width: 'auto',
												height: 'auto',
												objectFit: 'contain',
											}}
										/>
									</Box>
								);
							})}
						</Box>
					</Box>
					<ButtonWrapper
						onClick={handleDebitCardContinue}
						label={t('continue')}
						classList="!primary-bg !text-white !rounded-lg !py-3 !px-6 hover:!opacity-90 !mt-auto"
					/>
				</Paper>

				{/* Bank Transfer Option */}
				<Paper
					elevation={2}
					className="!p-6 !rounded-lg !bg-white flex flex-col justify-between"
					style={{ minHeight: '300px' }}
				>
					<Box className="flex flex-col align-center">
						<Typography
							variant="h5"
							className="!font-bold !text-gray-800 !mb-4"
						>
							{t('bankTransfer')}
						</Typography>
						<Typography
							variant="body2"
							className="!text-gray-500 !mt-7"
						>
							{t('bankTransferDescription')}
						</Typography>
					</Box>
					<ButtonWrapper
						onClick={handleBankTransferViewDetails}
						label={t('viewDetails')}
						classList="!primary-bg !text-white !rounded-lg !py-3 !px-6 hover:!opacity-90 !mt-auto"
					/>
				</Paper>
			</Box>
		</Box>
	);
};

